<template>
  <div class="header-container">
    <div class="header-status">
      <h1 :class="`header-text status-${pickup.status || 'held'}`">
        {{ (pickup.status || '-') | titleize }}
      </h1>
    </div>

    <div class="header-detail-container">
      <h1 class="header-code pb-2">
        <u
          v-tooltip="`Click to Copy`"
          v-clipboard:copy="pickup.booking_reference"
          v-clipboard:success="() => $message.success('Booking Reference copied to clipboard')"
        >{{ pickup.booking_reference }}</u> for {{ pickup.account.name }}
      </h1>
      <el-row :gutter="15">
        <el-col :span="8">
          <p>
            <b>Pickup Type</b><br>
            {{ (pickup.type || '-') | titleize }}
          </p>

          <p>
            <b>Booked At</b><br>
            {{ pickup.created_at ? $moment(pickup.created_at).format('llll') : '-' }}
          </p>
        </el-col>

        <el-col :span="8">
          <p>
            <b>Created By</b><br>
            <span class="text-uppercase">{{ $_.get(pickup, 'profile.name', '-') }}</span>
          </p>

          <p>
            <b>Last Modified By</b><br>
            <span class="text-uppercase">{{ $_.get(latestEvent, 'profile.name', '-') }}</span>
          </p>
        </el-col>

        <el-col :span="8">
          <p>
            <b>Total Items, Weight, &amp; Volume</b><br>
            {{ `${itemsCount} ${itemsCount > 0 ? 'items' : 'item'}` }}, {{ itemsWeight }}kg, {{ itemsVolume }}m<sup>3</sup>
          </p>

          <p>
            <b>Largest Item</b><br>
            {{ largestItemDimensions.join(' x ') }}cm
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pickup: {
      type: Object,
      required: true
    }
  },
  computed: {
    latestEvent () {
      const events = this.pickup.$fields.events.copy()

      events
        .sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at)
        })

      return events.shift()
    },
    itemsWeight () {
      let weight = 0

      if (this.pickup.consignments.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          weight += item.item_weight ? parseFloat(item.item_weight) : 0
        })
      } else if (this.pickup.items.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          weight += item.weight
        })
      }

      return weight
    },
    itemsVolume () {
      let volume = 0

      if (this.pickup.consignments.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          volume += item.item_cube ? parseFloat(item.item_cube * item.item_qty) : 0
        })
      } else if (this.pickup.items.length > 0) {
        this.getPickupItems(this.pickup).map(item => {
          volume += ((item.length * item.width * item.height) * item.item_count) / 1000000
        })
      }

      return volume
    },
    itemsCount () {
      let count = 0

      if (this.pickup.consignments.length > 0) {
        count = this
          .getPickupItems(this.pickup)
          .map(i => i.item_qty)
          .reduce((total, qty) => total + parseInt(qty), 0)
      } else if (this.pickup.items.length > 0) {
        count = this
          .getPickupItems(this.pickup)
          .map(i => i.item_count)
          .reduce((total, qty) => total + parseInt(qty), 0)
      }

      return count
    },
    largestItemDimensions () {
      let dimension = [0, 0, 0]

      this.getPickupItems(this.pickup).map(item => {
        let length = item.item_length || item.length || 0
        let width = item.item_width || item.width || 0
        let height = item.item_height || item.height || 0

        let _total = length + width + height
        let dimensionTotal = dimension.reduce((total, d) => total + d, 0)
        if (_total > dimensionTotal) {
          dimension[0] = length
          dimension[1] = width
          dimension[2] = height
        }
      })

      return dimension
    }
  },
  methods: {
    getPickupItems (pickup) {
      let items = []
      if (pickup.consignments.length > 0) {
        pickup.consignments.map(con => {
          items = items.concat(con.items)
        })
        return items
      } else if (pickup.items.length > 0) {
        return items.concat(pickup.items)
      } else { return [] }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "variables";
.header-container {
  display: flex;
  align-items: center;
  .header-status {
    padding: 0px 50px 0px 30px;
    .header-text {
      font-size: 2rem; text-align: center;
    }
    .status-hidden {
      color: $info;
    }
    .status-cancelled {
      color: $danger;
    }
    .status-held {
      color: $warning;
    }
    .status-error {
      color: $danger;
    }
    .status-pending {
      color: $warning;
    }
    .status-processing {
      color: $warning;
    }
    .status-processed {
      color: $primary;
    }
    .status-confirmed {
      color: $success;
    }
  }
  .header-detail-container {
    flex: 1;
    .header-code {
      cursor: pointer;
      font-size: 2rem; margin-bottom: 5px;
    }
  }
}
</style>
